// extracted by mini-css-extract-plugin
export default {"homeContainer":"ConvertiSegnalazione_homeContainer__aXA+6"};